import { MAX_PASSWORD_LENGTH } from '@/consts';
import { INPUT_MSG } from '@/consts/message';
import clsx from 'clsx';

interface IProps {
  newPassword: string;
  confirmPassword: string;
  isNewPasswordValid: boolean;
  isNotMatchPassword: boolean;
  isCheckPasswordDisabled: boolean;
  isConfirmPasswordValid?: boolean;
  isPwdChangeSuccessModalOpen: boolean;
  isPwdChangeFailedModalOpen: boolean;
  onChangeNewPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeConfirmPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onBlurNewPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onKeyDownCheckNewPassword: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClickCompleteBtn: () => void;
  onClickPwdChangeSuccessModalConfirm: () => void;
  onClickPwdChangeFailedModalConfirm: () => void;
  onBlurPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

const CheckPwdSettingView = ({
  newPassword,
  confirmPassword,
  isNewPasswordValid,
  isNotMatchPassword,
  isCheckPasswordDisabled,
  isConfirmPasswordValid,
  isPwdChangeSuccessModalOpen,
  isPwdChangeFailedModalOpen,
  onChangeNewPassword,
  onChangeConfirmPassword,
  onBlurNewPassword,
  onKeyDownCheckNewPassword,
  onClickCompleteBtn,
  onClickPwdChangeSuccessModalConfirm,
  onClickPwdChangeFailedModalConfirm,
  onBlurPassword,
}: IProps) => {
  const isCompleteBtnDisabled = isNotMatchPassword || isCheckPasswordDisabled || confirmPassword.length === 0;

  return (
    <div className="password-reset-content setting-container">
      <div className="password-reset-card">
        <h2 className="password-reset-title heading-4 font-bold">비밀번호 재설정</h2>

        <div className="password-reset-form">
          <div className="password-reset-form-item">
            <label htmlFor="new-password" className="password-label text-base font-medium">
              새로운 비밀번호를 입력해주세요
            </label>
            <input
              type="password"
              id="new-password"
              name="new-password"
              placeholder="영문, 숫자, 특수문자 포함 8~20자 입력"
              className="password-input text-base font-normal"
              value={newPassword}
              maxLength={MAX_PASSWORD_LENGTH}
              onChange={onChangeNewPassword}
              onBlur={onBlurNewPassword}
            />
            {isNewPasswordValid && newPassword.length > 0 && (
              <p className="password-error-message text-sm font-normal right">{INPUT_MSG.INVALID_PASSWORD}</p>
            )}
          </div>

          <div className="password-reset-form-item">
            <label htmlFor="new-password-confirm" className="password-label text-base font-medium">
              비밀번호를 다시 입력해주세요
            </label>
            <input
              type="password"
              id="new-password-confirm"
              name="new-password-confirm"
              placeholder="비밀번호 확인"
              className="password-input text-base font-normal"
              value={confirmPassword}
              maxLength={MAX_PASSWORD_LENGTH}
              onChange={onChangeConfirmPassword}
              onKeyDown={onKeyDownCheckNewPassword}
              onBlur={onBlurPassword}
            />
            {isNotMatchPassword && isConfirmPasswordValid && (
              <p className="password-error-message text-sm font-normal right">{INPUT_MSG.CHECK_PWD_FAILED}</p>
            )}
          </div>

          <button
            type="button"
            className={clsx('password-complete-btn btn-primary text-lg font-semibold', {
              active: !isCompleteBtnDisabled,
            })}
            disabled={isCompleteBtnDisabled}
            onClick={onClickCompleteBtn}
          >
            완료
          </button>
        </div>
      </div>

      {/* 비밀번호 변경 성공 모달 */}
      <div className={clsx('modal-overlay', !isPwdChangeSuccessModalOpen && 'hidden')} id="passwordConfirmModal">
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickPwdChangeSuccessModalConfirm}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/success-icon.png" alt="성공 아이콘" className="modal-icon" />
            </div>

            <h2 className="modal-warning-title text-lg font-bold">비밀번호가 재설정되었습니다.</h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickPwdChangeSuccessModalConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </div>

      {/* 비밀번호 변경 실패 모달 */}
      <div className={clsx('modal-overlay', !isPwdChangeFailedModalOpen && 'hidden')} id="passwordFailedModal">
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickPwdChangeFailedModalConfirm}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            </div>

            <h2 className="modal-warning-title text-lg font-bold">비밀번호 재설정에 실패했습니다.</h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickPwdChangeFailedModalConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckPwdSettingView;
